/**
 main
 Created by RuSsCiTy on 07.05.2018
 **/

import initCompatibility from "./init/compatibility";
import initStyle from "./init/style";
import MessageHub, { mainChannel } from "./init/message-hub";
import ViewManager from "./managers/view-manager";
import CookieManager from "./managers/cookie-manager";
import { api } from "./managers/api-manager";
import MyLocaleManager from "./init/locales";
import { waitForBrowserInfo } from "./managers/browser-manager";

api.init = options => {
  if (initCompatibility()) {
    /** All possible styles like bootstrap etc. which are used on the whole page */
    initStyle();

    /** Creates channels to communicate between components */
    new MessageHub();

    waitForBrowserInfo(options).then(answer => {
      /** Manages translations */
      new MyLocaleManager(answer.data);
      /** Manages all views, can show one or other page */
      new ViewManager(options);
      /** Decides if it should be shown */
      new CookieManager(answer.data);
    });

    mainChannel.trigger("ready");
  }
};



// WEBPACK FOOTER //
// ./src-cookie-manager/main.js